import {OpzioniItem} from "../gestversore/types";



export const TipoProgList: OpzioniItem[] = [
  { id: "STANDARD",  label: "STANDARD" },
  { id: "NON STANDARD",  label: "NON STANDARD" },
  { id: "SUPPORTO",  label: "SUPPORTO" },
  { id: "FORMAZIONE",  label: "FORMAZIONE" },
];

export const TipoMigList: OpzioniItem[] = [
  { id: "CLOUD ADOPTION",  label: "CLOUD ADOPTION" },
  { id: "EREADY",  label: "EREADY" },
  { id: "E3",  label: "E3" },
  { id: "EMBYON",  label: "EMBYON" },
  { id: "TSA",  label: "TSA" },
  { id: "ALYANTE",  label: "ALYANTE" },
  { id: "ACG",  label: "ACG" },
];

export const TipoInstList: OpzioniItem[] = [
  { id: "CLOUDTS",  label: "CLOUDTS" },
  { id: "CLOUDCLICK",  label: "CLOUDCLICK" },
  { id: "CLOUDCLIENTE",  label: "CLOUDCLIENTE" },
  { id: "ONPREM",  label: "ONPREM" },
];

export const CompProgList: OpzioniItem[] = [
  { id: "BASSA",  label: "BASSA" },
  { id: "MEDIA",  label: "MEDIA" },
  { id: "ALTA",  label: "ALTA" },
];

export const FlgDMSList: OpzioniItem[] = [
  { id: "S",  label: "S" },
  { id: "N",  label: "N" },
];

export const FlgMONList: OpzioniItem[] = [
  { id: "S",  label: "S" },
  { id: "N",  label: "N" },
];

export const FlgTestList: OpzioniItem[] = [
  { id: "S",  label: "S" },
  { id: "N",  label: "N" },
];


export type DatiProg = {
  id?: string;
  ref?: string;
  refcli?: string;
  tipoprog?: string;
  compprog?: string;
  datakickoffpian?: Date | null;
  datakickoffeff?: Date | null;
  datagantt?: Date | null;
  datagolivepian?: Date | null;
  datagoliveeff?: Date | null;
  data1sal?: Date | null;
  data2sal?: Date | null;
  data3sal?: Date | null;
  data4sal?: Date | null;
  data5sal?: Date | null;
  percomp?: number | null;
  tipoinst?: string;
  flgdms?: string;
  codprogdms?: string;
  datafirmakickoff?: Date | null;
  datacoll?: Date | null;
  note?: string;
  ditta?: number;
  tipomig?: string;
  datapercomp?: Date | null;
  dataagg?: Date | null;
  ricavi?: number |null;
  datatest?: Date | null;

};

export type DatiProgApiResponse = {
  results: Array<DatiProg>;
  count: number;
};



export function mapJsonToDatiProgApiResponse(jsonData: any): DatiProgApiResponse {
 const mappedData: DatiProgApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      id: item.BT25_CODPROG_VBT01,
      ref: item.BT25_REF,
      refcli: item.BT25_REFCLI,
      tipoprog: item.BT25_TIPOPROG,
      compprog: item.BT25_COMPPROG,
      datakickoffpian: item.BT25_DATAKICKOFFPIAN,
      datakickoffeff: item.BT25_DATAKICKOFFEFF,
      datagantt: item.BT25_DATAGANTT,
      datagolivepian: item.BT25_DATAGOLIVEPIAN,
      dataGoLiveEff: item.BT25_DATAGOLIVEEFF,
      data1sal: item.BT25_DATA1SAL,
      data2sal: item.BT25_DATA2SAL,
      data3sal: item.BT25_DATA3SAL,
      data4sal: item.BT25_DATA4SAL,
      data5sal: item.BT25_DATA5SAL,
      percomp: item.BT25_PERCOMP,
      tipoinst: item.BT25_TIPOINST,
      flgdms: item.BT25_FLGDMS,
      codprogdms: item.BT25_CODPROGDMS,
      datafirmakickoff: item.BT25_DATAFIRMAKICKOFF,
      datacoll: item.BT25_DATACOLL,
      note: item.BT25_NOTE,
      ditta: item.BT25_DITTA,
      tipomig: item.BT25_TIPOMIG,
      datapercomp: item.BT25_DATAPERCOMP,
      dataagg: item.BT25_DATAAGG,
      ricavi: item.BT25_RICAVI,
      datatest: item.BT25_DATATEST,

    }))
  };
  return mappedData;
};

export function mapDatiProgToJson(datiProg: DatiProg) {
  return {
    BT25_CODPROG_VBT01: datiProg.id,
    BT25_REF: datiProg.ref,
    BT25_REFCLI: datiProg.refcli,
    BT25_TIPOPROG: datiProg.tipoprog,
    BT25_COMPPROG: datiProg.compprog,
    BT25_DATAKICKOFFPIAN: datiProg.datakickoffpian,
    BT25_DATAKICKOFFEFF: datiProg.datakickoffeff,
    BT25_DATAGANTT: datiProg.datagantt,
    BT25_DATAGOLIVEPIAN: datiProg.datagolivepian,
    BT25_DATAGOLIVEEFF: datiProg.datagoliveeff,
    BT25_DATA1SAL: datiProg.data1sal,
    BT25_DATA2SAL: datiProg.data2sal,
    BT25_DATA3SAL: datiProg.data3sal,
    BT25_DATA4SAL: datiProg.data4sal,
    BT25_DATA5SAL: datiProg.data5sal,
    BT25_PERCOMP: datiProg.percomp,
    BT25_TIPOINST: datiProg.tipoinst,
    BT25_FLGDMS: datiProg.flgdms,
    BT25_CODPROGDMS: datiProg.codprogdms,
    BT25_DATAFIRMAKICKOFF: datiProg.datafirmakickoff,
    BT25_DATACOLL: datiProg.datacoll,
    BT25_NOTE: datiProg.note,
    BT25_DITTA: datiProg.ditta,
    BT25_TIPOMIG: datiProg.tipomig,
    BT25_DATAPERCOMP: datiProg.datapercomp,
    BT25_DATAAGG: datiProg.dataagg,
    BT25_RICAVI: datiProg.ricavi,
    BT25_DATATEST: datiProg.datatest,

  };
};

export function mapJsonToDatiProg(jsonData: any): DatiProg {
  return {
    id: jsonData.BT25_CODPROG_VBT01,
    ref: jsonData.BT25_REF,
    refcli: jsonData.BT25_REFCLI,
    tipoprog: jsonData.BT25_TIPOPROG,
    compprog: jsonData.BT25_COMPPROG,
    datakickoffpian: jsonData.BT25_DATAKICKOFFPIAN ? new Date(jsonData.BT25_DATAKICKOFFPIAN) : null,
    datakickoffeff: jsonData.BT25_DATAKICKOFFEFF ? new Date(jsonData.BT25_DATAKICKOFFEFF) : null,
    datagantt: jsonData.BT25_DATAGANTT ? new Date(jsonData.BT25_DATAGANTT) : null,
    datagolivepian: jsonData.BT25_DATAGOLIVEPIAN ? new Date(jsonData.BT25_DATAGOLIVEPIAN) : null,
    datagoliveeff: jsonData.BT25_DATAGOLIVEEFF ? new Date(jsonData.BT25_DATAGOLIVEEFF) : null,
    data1sal: jsonData.BT25_DATA1SAL ? new Date(jsonData.BT25_DATA1SAL) : null,
    data2sal: jsonData.BT25_DATA2SAL ? new Date(jsonData.BT25_DATA2SAL) : null,
    data3sal: jsonData.BT25_DATA3SAL ? new Date(jsonData.BT25_DATA3SAL) : null,
    data4sal: jsonData.BT25_DATA4SAL ? new Date(jsonData.BT25_DATA4SAL) : null,
    data5sal: jsonData.BT25_DATA5SAL ? new Date(jsonData.BT25_DATA5SAL) : null,
    percomp: jsonData.BT25_PERCOMP,
    tipoinst: jsonData.BT25_TIPOINST,
    flgdms: jsonData.BT25_FLGDMS,
    codprogdms: jsonData.BT25_CODPROGDMS,
    datafirmakickoff: jsonData.BT25_DATAFIRMAKICKOFF ? new Date(jsonData.BT25_DATAFIRMAKICKOFF) : null,
    datacoll: jsonData.BT25_DATACOLL ? new Date(jsonData.BT25_DATACOLL) : null,
    note: jsonData.BT25_NOTE,
    ditta: jsonData.BT25_DITTA,
    tipomig: jsonData.BT25_TIPOMIG,
    datapercomp: jsonData.BT25_DATAPERCOMP ? new Date(jsonData.BT25_DATAPERCOMP) : null,
    dataagg: jsonData.BT25_DATAAGG ? new Date(jsonData.BT25_DATAAGG) : null,
    ricavi: jsonData.BT25_RICAVI,
    datatest: jsonData.BT25_DATATEST,

  };
}


export type DatiProgDTO = {
  id?: string;
  codprog?: string;
  ref?: string;
  refcli?: string;
  tipoprog?: string;
  compprog?: string;
  datakickoffpian?: Date | null;
  datakickoffeff?: Date | null;
  datagantt?: Date | null;
  datagolivepian?: Date | null;
  datagoliveeff?: Date | null;
  data1sal?: Date | null;
  data2sal?: Date | null;
  data3sal?: Date | null;
  data4sal?: Date | null;
  data5sal?: Date | null;
  percomp?: number | null;
  tipoinst?: string;
  flgdms?: string;
  codprogdms?: string;
  datafirmakickoff?: Date | null;
  datacoll?: Date | null;
  note?: string;
  ditta?: number;
  tipomig?: string;
  datapercomp?: Date | null;
  dataagg?: Date | null;
  desprog?: string;
  ricavi?: number;
  datatest?: string;
  statoprog?: string;
  flgcollord?: string;
  indclibloc?: string;
};

export type DatiProgDTOApiResponse = {
  results: Array<DatiProgDTO>;
  count: number;
};

export function mapJsonToDatiProgDTOApiResponse(jsonData: any): DatiProgDTOApiResponse {
 const mappedData: DatiProgDTOApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      id: item.VBT25_ID,
      codprog: item.VBT25_CODPROG,
      ref: item.VBT25_REF,
      refcli: item.VBT25_REFCLI,
      tipoprog: item.VBT25_TIPOPROG,
      compprog: item.VBT25_COMPPROG,
      datakickoffpian: item.VBT25_DATAKICKOFFPIAN,
      datakickoffeff: item.VBT25_DATAKICKOFFEFF,
      datagantt: item.VBT25_DATAGANTT,
      datagolivepian: item.VBT25_DATAGOLIVEPIAN,
      dataGoLiveEff: item.VBT25_DATAGOLIVEEFF,
      data1sal: item.VBT25_DATA1SAL,
      data2sal: item.VBT25_DATA2SAL,
      data3sal: item.VBT25_DATA3SAL,
      data4sal: item.VBT25_DATA4SAL,
      data5sal: item.VBT25_DATA5SAL,
      percomp: item.VBT25_PERCOMP,
      tipoinst: item.VBT25_TIPOINST,
      flgdms: item.VBT25_FLGDMS,
      codprogdms: item.VBT25_CODPROGDMS,
      datafirmakickoff: item.VBT25_DATAFIRMAKICKOFF,
      datacoll: item.VBT25_DATACOLL,
      note: item.VBT25_NOTE,
      ditta: item.VBT25_DITTA,
      tipomig: item.VBT25_TIPOMIG,
      datapercomp: item.VBT25_DATAPERCOMP,
      dataagg: item.VBT25_DATAAGG,
      desprog: item.VBT25_DESPROG,
      ricavi: item.VBT25_RICAVI,
      datatest: item.VBT25_DATATEST,
      statoprog: item.VBT25_STATOPROG,
      flgcollord: item.VBT25_FLGCOLLORD,
      indclibloc: item.VBT25_INDCLIBLOC,


    }))
  };
  return mappedData;
};



